import { Archive, CheckCircle2, Clock, FileText, PauseCircle, XCircle } from 'lucide-react';
import { Stat } from '@/client/components/common/StatsGrid';

export function buildListingStats(stats: any): Stat[] {
  const s = stats?.by_status ?? {};
  const live = s.LIVE ?? 0;
  const denom = Object.values(s).reduce((sum: number, n: any) => sum + (n ?? 0), 0);
  const share = (n: number) => (denom > 0 ? `${((n / denom) * 100).toFixed(1)}% of all` : undefined);

  return [
    { key: 'live', label: 'Active', value: live, hint: share(live), icon: CheckCircle2, tone: 'bg-emerald-50 text-emerald-600' },
    { key: 'draft', label: 'Draft', value: s.DRAFT ?? 0, hint: share(s.DRAFT ?? 0), icon: FileText, tone: 'bg-gray-100 text-gray-600' },
    { key: 'review', label: 'In review', value: s.REVIEW ?? 0, hint: share(s.REVIEW ?? 0), icon: Clock, tone: 'bg-amber-50 text-amber-600' },
    { key: 'rejected', label: 'Rejected', value: s.REJECTED ?? 0, hint: share(s.REJECTED ?? 0), icon: XCircle, tone: 'bg-rose-50 text-rose-600' },
    { key: 'suspended', label: 'Suspended', value: s.SUSPENDED ?? 0, hint: share(s.SUSPENDED ?? 0), icon: PauseCircle, tone: 'bg-orange-50 text-orange-600' },
    { key: 'new', label: 'New', value: stats?.created_last_7d ?? 0, hint: `${stats?.created_last_30d ?? 0} in last 30d`, icon: Archive, tone: 'bg-blue-50 text-blue-600' },
  ];
}
